import React, { memo, useEffect, useState } from 'react'

import SpinnerWithLabel from '@components/SpinnerWithLabel'

const SpinnerWithFakeProgress = () => {
  const [value, setValue] = useState(0)

  useEffect(() => {
    window.setInterval(() => {
      setValue(existingValue => Math.min(99, existingValue + Math.floor(Math.random() * 10)))
    }, 300)
  }, [])

  return <SpinnerWithLabel value={value} />
}

export default memo(SpinnerWithFakeProgress)
